<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-c">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                </div>
                <div class="talent-right-wrapper">
                    <label v-if="item.section.toLowerCase()=='l' && subitem.index!='10'" :class="setl.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setl" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setl,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='l' && subitem.index=='10'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setl" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='t' && subitem.index!='10'" :class="sett.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sett" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sett,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='t' && subitem.index=='10'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sett" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='p' && subitem.index!='10'" :class="setp.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setp" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setp,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='p' && subitem.index=='10'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setp" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
export default {
    name: "Question_set_d",
    data(){
        return {
            setl: [],
            sett: [],
            setp: [],
            conclusion: {},
            loadIndex: 0,
            data:[{
                "language": "en",
                "title": "II. Capability",
                "description": "Place a tick ( ✔ ) in the box against all the items that are true for you. You can tick as many as you want.",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "I am good at explaining things to others"
                    },{
                        "index": 2,
                        "title": "I have participated in fund raising drives"
                    },{
                        "index": 3,
                        "title": "I am competent at entertaining people older than I"
                    },{
                        "index": 4,
                        "title": "I can be a good host/hostess"
                    },{
                        "index": 5,
                        "title": "I can teach children easily"
                    },{
                        "index": 6,
                        "title": "I am good at helping people who are troubled or upset"
                    },{
                        "index": 7,
                        "title": "I have worked as volunteer in a hospital, clinic or home"
                    },{
                        "index": 8,
                        "title": "I can plan work or social events"
                    },{
                        "index": 9,
                        "title": "I am a good judge of personality"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "I have been elected to hold an important role in school"
                    },{
                        "index": 2,
                        "title": "I can supervise the work of others"
                    },{
                        "index": 3,
                        "title": "I have unusual energy and enthusiasm"
                    },{
                        "index": 4,
                        "title": "I am good at getting people to do things my way"
                    },{
                        "index": 5,
                        "title": "I am good at selling ideas to people"
                    },{
                        "index": 6,
                        "title": "I have organized a club or activities"
                    },{
                        "index": 7,
                        "title": "I have started my own business or organization"
                    },{
                        "index": 8,
                        "title": "I know how to be a successful leader"
                    },{
                        "index": 9,
                        "title": "I am a good debater"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "I can type 40 words in a minute"
                    },{
                        "index": 2,
                        "title": "I can operate a photocopier/fax machine"
                    },{
                        "index": 3,
                        "title": "I can take shorthand"
                    },{
                        "index": 4,
                        "title": "I have held an office job"
                    },{
                        "index": 5,
                        "title": "I can use a printing calculator"
                    },{
                        "index": 6,
                        "title": "I can do lots of paperwork in a short time"
                    },{
                        "index": 7,
                        "title": "I can use word processing, excel and database software"
                    },{
                        "index": 8,
                        "title": "I can do simple accounting"
                    },{
                        "index": 9,
                        "title": "I can keep accurate record of payments or sales"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "II. 本领",
                "description": "在那些你胜任的领域里画 （ ✔ ）。 你可以选择超过一个。",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "我善于向他人解释事情的原由"
                    },{
                        "index": 2,
                        "title": "我曾参与募款活动"
                    },{
                        "index": 3,
                        "title": "我善于招待比我年长的人"
                    },{
                        "index": 4,
                        "title": "我可以成为一个好主人/女主人"
                    },{
                        "index": 5,
                        "title": "我善于教导孩子"
                    },{
                        "index": 6,
                        "title": "我善于开解伤心或面对苦难的人"
                    },{
                        "index": 7,
                        "title": "我曾在医院、药房或家庭当义工"
                    },{
                        "index": 8,
                        "title": "我可以计划工作或社区活动"
                    },{
                        "index": 9,
                        "title": "我善于判断他人的个性"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "我曾挑选担任学校的要职"
                    },{
                        "index": 2,
                        "title": "我可以监督他人工作"
                    },{
                        "index": 3,
                        "title": "我拥有超常的精力和热忱"
                    },{
                        "index": 4,
                        "title": "我能让他人跟着我的方法行事"
                    },{
                        "index": 5,
                        "title": "我善于提供他人销售点子"
                    },{
                        "index": 6,
                        "title": "我曾组织一个团体或活动"
                    },{
                        "index": 7,
                        "title": "我曾开始经营自己的生意或团体"
                    },{
                        "index": 8,
                        "title": "我知道如何成为一位成功的领袖"
                    },{
                        "index": 9,
                        "title": "我精于辩论"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "我每分钟能打40个字"
                    },{
                        "index": 2,
                        "title": "我可以操作影印机/传真机"
                    },{
                        "index": 3,
                        "title": "我会速记"
                    },{
                        "index": 4,
                        "title": "我曾执行办公室工作"
                    },{
                        "index": 5,
                        "title": "我会使用打印计算机"
                    },{
                        "index": 6,
                        "title": "我可以在短时间内执行多项文书工作"
                    },{
                        "index": 7,
                        "title": "我会使用word processing, excel 和database 软件"
                    },{
                        "index": 8,
                        "title": "我可以处理简单的会计"
                    },{
                        "index": 9,
                        "title": "我可以保存准确地收款或销售记录"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "II. Kemampuam",
                "description": "Sila tanda ( ✔ ) di dalam kotak terhadap semua perkara-perkara yang benar untuk anda. Anda boleh tanda seberapa banyak yang anda mahu.",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "Saya boleh menerangkan perkara kepada orang dengan baik"
                    },{
                        "index": 2,
                        "title": "Saya pernah menyertai kutipan derma"
                },{
                        "index": 3,
                        "title": "Saya mampu menghiburkan orang yang lebih tua daripada saya"
                    },{
                        "index": 4,
                        "title": "Saya boleh menjadi tuan rumah yang baik"
                    },{
                        "index": 5,
                        "title": "Saya boleh mengajar anak-anak dengan senang"
                    },{
                        "index": 6,
                        "title": "Saya boleh membantu orang yang bermasalah atau sedih"
                    },{
                        "index": 7,
                        "title": "Saya pernah bekerja sebagai sukarelawan di hospital atau klinik"
                    },{
                        "index": 8,
                        "title": "Saya boleh merancang kerja atau acara-acara sosial"
                    },{
                        "index": 9,
                        "title": "Saya boleh menilai peribadi orang lain dengan tepat"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "Saya pernah dilantik untuk memegang tugas penting di sekolah"
                    },{
                        "index": 2,
                        "title": "Saya boleh menyelia kerja orang lain"
                    },{
                        "index": 3,
                        "title": "Saya mempunyai tenaga dan semangat yang luar biasa"
                    },{
                        "index": 4,
                        "title": "Saya boleh memujuk orang melakukan perkara mengikut cara saya"
                    },{
                        "index": 5,
                        "title": "Saya baik dalam menjual idea kepada orang"
                    },{
                        "index": 6,
                        "title": "Saya pernah menganjurkan kelab-kelab atau aktiviti-aktiviti"
                    },{
                        "index": 7,
                        "title": "Saya pernah memulakan perniagaan atau organisasi saya sendiri"
                    },{
                        "index": 8,
                        "title": "Saya tahu bagaimana untuk menjadi seorang pemimpin yang berjaya"
                    },{
                        "index": 9,
                        "title": "Saya adalah seorang pendebat yang bagus"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "Saya boleh menaip 40 perkataan dalam seminit"
                    },{
                        "index": 2,
                        "title": "Saya boleh mengendali mesin fotokopi/mesin faks"
                    },{
                        "index": 3,
                        "title": "Saya boleh mengambil trengkas"
                    },{
                        "index": 4,
                        "title": "Saya pernah memegang satu kerja pejabat"
                    },{
                        "index": 5,
                        "title": "Saya boleh menggunakan kalkulator percetakan"
                    },{
                        "index": 6,
                        "title": "Saya boleh melakukan banyak kerja menulis dalam masa yang singkat"
                    },{
                        "index": 7,
                        "title": "Saya boleh menggunakan word processing, excel & database software"
                    },{
                        "index": 8,
                        "title": "Saya boleh melakukan perakaunan yang mudah"
                    },{
                        "index": 9,
                        "title": "Saya boleh menyimpan rekod bayaran atau jualan yang tepat"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.l2 = 0;
            this.conclusion.t2 = 0;
            this.conclusion.p2 = 0;

            if(this.setl.length > 0){
                for(var a = 0 ; a < this.setl.length; a++){
                    this.conclusion.l2 += 1;
                }   
            }
            if(this.sett.length > 0){
                for(var b = 0; b < this.sett.length; b++){
                    this.conclusion.t2 += 1;
                }
            }
            if(this.setp.length > 0){
                for(var c = 0; c < this.setp.length; c++){
                    this.conclusion.p2 += 1;
                }
            }
            console.log(this.conclusion)
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'question-set-e'})
        }
    }
}
</script>